import React, { useState, useEffect } from "react";
import "./Destinations.css";
import { Title } from "../../../../components";
import { Container } from "react-bootstrap";
import image1 from "../../../../assets/images/home/1.png";
import image2 from "../../../../assets/images/home/2.png";
import image3 from "../../../../assets/images/home/3.png";
import image4 from "../../../../assets/images/home/4.png";
import image5 from "../../../../assets/images/home/5.png";
import image6 from "../../../../assets/images/home/6.png";
import rotetePlane from "../../../../assets/images/home/rotate-plane.svg";
import StaticImage from "../../../../assets/images/package-img-default.png";
import { axiosGet } from "../../../../utils/apis/api";
import { useNavigate } from "react-router-dom";


const Destinations = ({ pageData, url }) => {
  const destinationData = pageData?.templates?.find(
    (template) => template.section === "Destination"
  );
const {
  destination_title,
  destination_subtitle,
  destination_desc,
  destination_icon,
  destination_background,
} = destinationData?.data || {};

  const defaultGridClasses = [
    "item-1",
    "item-2",
    "item-1",
    "item-2",
    "item-1",
    "item-1",
  ];
  const smallScreenGridClasses = [
    "item-1",
    "item-1",
    "item-2",
    "item-1",
    "item-1",
    "item-2",
  ];
  const [destinationsData, setDestinationsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleDestinationClick = (locationName) => {
  const params = new URLSearchParams();
  params.set("destinations", locationName);
  navigate(`/packages?${params.toString()}`);
};


  // const destinationsData = [
  //   { image: image1, title: "London", location: "USA" },
  //   { image: image2, title: "Chiang Mai", location: "Thailand" },
  //   { image: image3, title: "Chiang Mai", location: "Thailand" },
  //   { image: image4, title: "Alaska", location: "USA" },
  //   { image: image5, title: "Maldives", location: "Thailand" },
  //   { image: image6, title: "New York", location: "USA" },
  // ]

  const fetchDestination = async () => {
    try {
      const apiUrl = `${url}/api/method/alltimes.www.api.get_top_destinations`;

      setIsLoading(true);
      const response = await axiosGet(apiUrl);
      const result = response.message;

      setDestinationsData(result || []);
      setIsLoading(false);
    } catch (error) {
      console.error("Failed to fetch top destinations:", error.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDestination();
  }, []);

  const [gridClasses, setGridClasses] = useState(defaultGridClasses);

  useEffect(() => {
    const updateGridClasses = () => {
      if (window.innerWidth < 768) {
        setGridClasses(smallScreenGridClasses);
      } else {
        setGridClasses(defaultGridClasses);
      }
    };

    updateGridClasses(); // Initial check
    window.addEventListener("resize", updateGridClasses);

    return () => window.removeEventListener("resize", updateGridClasses);
  }, []);

  const getAnimationClass = (index) => {
    if (index % 3 === 0) return "fade-right";
    if (index % 3 === 1) return "fade";
    return "fade-left";
  };

  return (
    <Container className="margin-top destinations-container">
      <img
        src={destination_icon ? url + destination_icon : rotetePlane}
        className="destinations-img"
        alt=""
      />
      <img
        src={
          destination_background
            ? url + destination_background
            : require("../../../../assets/images/home/bg1.png")
        }
        className="destinations-bg"
        alt=""
      />
      <Title
        desc={destination_subtitle}
        title={destination_title}
        para={destination_desc}
      />

      <div className="grid-container">
        {destinationsData.map((item, index) => (
          <div
            key={index}
            className={`grid-item ${gridClasses[index % gridClasses.length]}`}
            data-aos={getAnimationClass(index)}
            data-aos-duration="1500"
            onClick={() => handleDestinationClick(item.location)} 
            style={{ cursor: "pointer" }} 
          >
            <div className="grid-item-shadow"></div>
            <div className="destination-container">
              {/* <img src={item.image} className='destination-image' /> */}
              <img
                src={item.image ? `${url}/${item.image}` : StaticImage}
                className="destination-image" alt=""
              />
              <div className="destination-content">
                {/* <div className="destination-title">{item.destination_name}</div> */}
                {item.location_name && (
                  <div className="destination-location">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M13.3451 0.00354333L13.4077 0L13.4845 0.00472435L13.5376 0.0141732L13.6102 0.0348425L13.6734 0.0620079L13.7325 0.0956692L13.7856 0.135236L13.8341 0.179527L13.8648 0.21437L13.9132 0.282874L13.9439 0.339567C13.9715 0.398622 13.9892 0.460827 13.997 0.526181L14 0.588779C14 0.633268 13.9953 0.676575 13.9858 0.718701L13.9652 0.791338L10.1077 11.4667C10.0346 11.6259 9.91728 11.7608 9.76979 11.8553C9.6223 11.9498 9.45077 12.0001 9.27559 12C9.11785 12.0003 8.9627 11.9599 8.82518 11.8826C8.68767 11.8053 8.57247 11.6938 8.49075 11.5589L8.45236 11.4839L7.20867 6.7913L2.53386 5.5559C2.38811 5.48925 2.26242 5.38549 2.16935 5.25501C2.07629 5.12454 2.01911 4.97191 2.00354 4.8124L2 4.72441C2 4.3937 2.17776 4.09134 2.49665 3.91535L2.57933 3.87402L13.2193 0.0318897L13.2819 0.0141732L13.3451 0.00354333Z"
                        fill="#C2C2C2"
                      />
                    </svg>
                    <label>{item.location_name}</label>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
};

export default Destinations;
